export default "__VITE_ASSET__DrRTpEdn__"